import { render, staticRenderFns } from "./PersonalDetails.vue?vue&type=template&id=5e527c16&scoped=true&"
import script from "./PersonalDetails.vue?vue&type=script&lang=js&"
export * from "./PersonalDetails.vue?vue&type=script&lang=js&"
import style0 from "./PersonalDetails.vue?vue&type=style&index=0&id=5e527c16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e527c16",
  null
  
)

export default component.exports